import React from "react";
import UnderConstructionSection from "../../features/under-construction/under-construction-section";

function UnderConstruction() {
  return <UnderConstructionSection />;
}

export default UnderConstruction;
